import EcoImg from 'eco-design/base/eco-img';
import Link from 'next/link';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function A() {
    const { useLang, useRouter } = useGlobal();
    const { t } = useLang('wholehome');
    const { locale } = useRouter();

    return (
        <div className={`whole-home-A ${css['whole-home-A']}`}>
            <div className="img-box">
                <EcoImg
                    pc="https://websiteoss.ecoflow.com/_next/static/media/1.9ff1dd4f.jpg"
                    pad="https://websiteoss.ecoflow.com/_next/static/media/1.bdfa9f46.jpg"
                    h5="https://websiteoss.ecoflow.com/_next/static/media/1.bdfa9f46.jpg"
                />
            </div>
            <div className="text-wrapper">
                <p className="title">{t('secA_title')}</p>
                <p className="subtitle">{t('secA_subtitle')}</p>
            </div>

            <div className="card-box">
                <p className="card-title">{t('secA_card_title')}</p>
                <p className="card-text">{t('secA_card_text')}</p>
                <Link className="card-btn" href="https://www.ecoflow.com/ca/delta-pro-ultra " target="_blank">
                    {t('secA_card_btn')}
                </Link>
            </div>
        </div>
    );
}
